var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"special-case-step col-lg-10"},[_c('section',{staticClass:"step-group"},[_c('h3',[_vm._v(_vm._s(_vm.$t("common.notes")))]),_c('DxTextArea',{attrs:{"value":_vm.notes,"height":180,"disabled":_vm.saving},on:{"value-changed":function($event){return _vm.setNotes($event.value)}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }